const appConfig = {
    apiPrefix: 'https://zamanapi.rasaelapi.com',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig